import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

// Get token from sessionStorage or localStorage
const getToken = () => {
  // البحث في sessionStorage أولاً
  let storedUser = sessionStorage.getItem("loggedUser");
  if (!storedUser) {
    // إذا لم يوجد في sessionStorage، ابحث في localStorage
    storedUser = localStorage.getItem("loggedUser");

  }

  if (!storedUser) {
    throw new Error("No authentication token found");
  }

  const parsedUser = JSON.parse(storedUser);
  const token =
    parsedUser?.token ||
    parsedUser?.data?.token ||
    parsedUser?.user?.token ||
    parsedUser?.result?.token;

  if (!token) {
    throw new Error("No authentication token found");
  }

  // console.log('Token found:', token);
  return token;
};
// Fetch products
export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async ({ page = 1, filters = {} }, thunkAPI) => {
    try {
      const token = getToken();

      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(
          ([_, value]) => value !== "" && value !== null
        )
      );

      const query = new URLSearchParams({
        page,
        ...cleanFilters,
      }).toString();

      const response = await axios.get(
        `${BASE_URL}/dashboard/products?${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل تحميل المنتجات"
      );
    }
  }
);

//*********************************** */
// export const fetchProducts = createAsyncThunk(
//   "products/fetchProducts",
//   async (page = 1, thunkAPI) => {
//     try {
//       const token = getToken();
//       const response = await axios.get(
//         `${BASE_URL}/dashboard/products?page=${page}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       console.log('Products API Response:', response.data);
//       return response.data;
//     } catch (error) {
//       console.error("Products API Error:", error);
//       const message = error.response?.data?.message || "فشل في تحميل المنتجات";
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

// Fetch all categories for dropdowns
export const fetchAllCategories = createAsyncThunk(
  "products/fetchAllCategories",
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${BASE_URL}/dashboard/settings/categories`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Categories API Error:", error);
      const message = error.response?.data?.message || "فشل في تحميل التصنيفات";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch all grades for dropdowns
export const fetchAllGrades = createAsyncThunk(
  "products/fetchAllGrades",
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${BASE_URL}/dashboard/settings/grades`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Grades API Error:", error);
      const message = error.response?.data?.message || "فشل في تحميل الصفوف";
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const fetchAllProducts = createAsyncThunk(
  "products/fetchAllProducts",
  async (page = 1, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${BASE_URL}/dashboard/products?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Grades API Error:", error);
      const message = error.response?.data?.message || "فشل في تحميل المنتجات";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch all subjects for dropdowns
export const fetchAllSubjects = createAsyncThunk(
  "products/fetchAllSubjects",
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${BASE_URL}/dashboard/settings/subjects`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Subjects API Error:", error);
      const message = error.response?.data?.message || "فشل في تحميل المواد";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch all sections for dropdowns
export const fetchAllSections = createAsyncThunk(
  "products/fetchAllSections",
  async (_, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${BASE_URL}/dashboard/settings/sections`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Sections API Error:", error);
      const message = error.response?.data?.message || "فشل في تحميل الشعب";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get single product
export const getProductById = createAsyncThunk(
  "products/getProductById",
  async (id, thunkAPI) => {
    try {
      const token = getToken();
      const response = await axios.get(`${BASE_URL}/dashboard/products/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Get Product API Error:", error);
      const message =
        error.response?.data?.message || "فشل في تحميل بيانات المنتج";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Add product
export const addProduct = createAsyncThunk(
  "products/addProduct",
  async (productData, thunkAPI) => {
    try {
      const token = getToken();

      // إنشاء FormData
      const formData = new FormData();

      // إضافة البيانات الأساسية
      formData.append("title_en", productData.title_en);
      formData.append("title_ar", productData.title_ar);
      formData.append("subtitle_en", productData.subtitle_en);
      formData.append("subtitle_ar", productData.subtitle_ar);
      formData.append("status", productData.status);
      formData.append("desc_en", productData.desc_en);
      formData.append("desc_ar", productData.desc_ar);
      formData.append("note_en", productData.note_en);
      formData.append("note_ar", productData.note_ar);
      formData.append("fake_price", productData.fake_price);
      formData.append("real_price", productData.real_price);
      formData.append("discount", productData.discount);
      formData.append("preorder_capacity", productData.preorder_capacity ?? 0);
      formData.append("is_preorder", productData.is_preorder ? 1 : 0);
      formData.append("qty", productData.qty);
      formData.append("stock", productData.stock);
      formData.append("sku", productData.sku);
      formData.append("category_id", productData.category_id ?? "");
      formData.append("grade_id", productData.grade_id ?? "");
      formData.append("subject_id", productData.subject_id ?? "");
      formData.append("section_id", productData.section_id ?? "");
      formData.append("teacher_id", productData.teacher_id ?? "");
      formData.append("sort_by", productData.sort_by || 0);
      formData.append("is_free_shipping", productData.is_free_shipping ? 1 : 0);
      formData.append("is_sku", productData.is_sku ? 1 : 0);

      // إضافة product_sku
      if (Array.isArray(productData.product_sku)) {
        productData.product_sku.forEach((skuObj, index) => {
          formData.append(`product_sku[${index}][sku]`, skuObj.sku || "");
          formData.append(`product_sku[${index}][price]`, skuObj.price || "");
          formData.append(`product_sku[${index}][quantity]`, skuObj.quantity || "");
          if (Array.isArray(skuObj.items)) {
            skuObj.items.forEach((item, itemIndex) => {
              formData.append(`product_sku[${index}][items][${itemIndex}][variant_id]`, item.variant_id);
              formData.append(`product_sku[${index}][items][${itemIndex}][variant_value_id]`, item.variant_value_id);
            });
          }
        });
      }

      // إضافة المميزات
      if (Array.isArray(productData.features)) {
        productData.features.forEach((feature, index) => {
          formData.append(`features[${index}][text_en]`, feature.text_en);
          formData.append(`features[${index}][text_ar]`, feature.text_ar);
        });
      }

      if (Array.isArray(productData.sliders)) {
        productData.sliders.forEach((slider, index) => {
          formData.append(`sliders[${index}]`, slider);
        });
      }

      // إضافة الخصائص المخصصة
      if (productData.custom_attributes && typeof productData.custom_attributes === "object") {
        Object.entries(productData.custom_attributes).forEach(([key, val]) => {
          if (val !== undefined && val !== null && val !== "") {
            formData.append(`custom_attributes[${key}]`, val);
          }
        });
      }


      // console.log('Sending Product FormData:', formData);
      // console.log('API URL:', `${BASE_URL}/dashboard/products`);
      // console.log('Token:', token);

      // طباعة محتويات FormData
      // for (let pair of formData.entries()) {
      //   console.log('FormData entry:', pair[0], pair[1]);
      // }
      // for (let pair of formData.entries()) {
      //   console.log(pair[0], pair[1]);
      // }
      const response = await axios.post(
        `${BASE_URL}/dashboard/products`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log('Add Product Response:', response.data);
      return response.data;
    } catch (error) {
      console.error("Add Product Error:", error);
      const message = error.response?.data?.message || "فشل في إضافة المنتج";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update product
export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ id, productData }, thunkAPI) => {
    try {
      const token = getToken();

      // إنشاء FormData
      const formData = new FormData();

      // إضافة البيانات الأساسية
      formData.append("title_en", productData.title_en);
      formData.append("title_ar", productData.title_ar);
      formData.append("subtitle_en", productData.subtitle_en);
      formData.append("subtitle_ar", productData.subtitle_ar);
      formData.append("status", productData.status);
      formData.append("desc_en", productData.desc_en);
      formData.append("desc_ar", productData.desc_ar);
      formData.append("note_en", productData.note_en);
      formData.append("note_ar", productData.note_ar);
      formData.append("fake_price", productData.fake_price);
      formData.append("real_price", productData.real_price);
      formData.append("discount", productData.discount);
      formData.append("qty", productData.qty);
      formData.append("stock", productData.stock);
      formData.append("sku", productData.sku);
      formData.append("category_id", productData.category_id ?? "");
      formData.append("grade_id", productData.grade_id ?? "");
      formData.append("subject_id", productData.subject_id ?? "");
      formData.append("section_id", productData.section_id ?? "");
      formData.append("teacher_id", productData.teacher_id ?? "");
      formData.append("preorder_capacity", productData.preorder_capacity ?? 0);
      formData.append("is_preorder", productData.is_preorder ? 1 : 0);
      formData.append("sort_by", productData.sort_by || 0);
      formData.append("is_free_shipping", productData.is_free_shipping ? 1 : 0);
      formData.append("is_sku", productData.is_sku ? 1 : 0);

      // إضافة product_sku
      if (Array.isArray(productData.product_sku)) {
        productData.product_sku.forEach((skuObj, index) => {
          formData.append(`product_sku[${index}][sku]`, skuObj.sku || "");
          formData.append(`product_sku[${index}][price]`, skuObj.price || "");
          formData.append(`product_sku[${index}][quantity]`, skuObj.quantity || "");
          if (Array.isArray(skuObj.items)) {
            skuObj.items.forEach((item, itemIndex) => {
              formData.append(`product_sku[${index}][items][${itemIndex}][variant_id]`, item.variant_id);
              formData.append(`product_sku[${index}][items][${itemIndex}][variant_value_id]`, item.variant_value_id);
            });
          }
        });
      }

      // إضافة المميزات
      if (Array.isArray(productData.features)) {
        productData.features.forEach((feature, index) => {
          formData.append(`features[${index}][text_en]`, feature.text_en);
          formData.append(`features[${index}][text_ar]`, feature.text_ar);
        });
      }

      if (Array.isArray(productData.sliders)) {
        productData.sliders.forEach((slider, index) => {
          formData.append(`sliders[${index}]`, slider);
        });
      }

      // إضافة الخصائص المخصصة
      if (productData.custom_attributes && typeof productData.custom_attributes === "object") {
        Object.entries(productData.custom_attributes).forEach(([key, val]) => {
          if (val !== undefined && val !== null && val !== "") {
            formData.append(`custom_attributes[${key}]`, val);
          }
        });
      }

      // // طباعة محتويات FormData
      // console.log("FormData contents:");
      // for (let pair of formData.entries()) {
      //   console.log(pair[0], pair[1]);
      // }

      // console.log("Sending Update Product FormData:", formData);

      const response = await axios.post(
        `${BASE_URL}/dashboard/products/${id}/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Update Product Response:", response.data);
      // console.log("Update Product Response:", response);
      return response.data;
    } catch (error) {
      console.error("Update Product Error:", error);
      const message = error.response?.data?.message || "فشل في تحديث المنتج";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete product
export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (id, thunkAPI) => {
    try {
      const token = getToken();

      const response = await axios.delete(
        `${BASE_URL}/dashboard/products/${id}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('Delete Product Response:', response.data);
      return { id, response: response.data };
    } catch (error) {
      console.error("Delete Product Error:", error);
      const message = error.response?.data?.message || "فشل في حذف المنتج";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  products: [],
  currentProduct: null,
  meta: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  },
  // Dropdown data
  categories: [],
  grades: [],
  subjects: [],
  sections: [],
  allProducts: [],
  // Loading states
  isLoading: false,
  getProductLoading: false,
  addLoading: false,
  updateLoading: false,
  deleteLoading: false,
  // Dropdown loading states
  categoriesLoading: false,
  gradesLoading: false,
  allProductsLoading: false,
  subjectsLoading: false,
  sectionsLoading: false,
  // Messages
  error: null,
  success: null,
  addSuccessMessage: null,
  addError: null,
  updateSuccessMessage: null,
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.addError = null;
      state.success = null;
      state.addSuccessMessage = null;
      state.updateSuccessMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch products
      .addCase(fetchProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "حدث خطأ في تحميل المنتجات";
      })

      // Get single product
      .addCase(getProductById.pending, (state) => {
        state.getProductLoading = true;
        state.error = null;
      })
      .addCase(getProductById.fulfilled, (state, action) => {
        state.getProductLoading = false;
        state.currentProduct = action.payload.data;
      })
      .addCase(getProductById.rejected, (state, action) => {
        state.getProductLoading = false;
        state.error =
          action.payload?.message || "حدث خطأ في تحميل بيانات المنتج";
      })

      // Add product
      .addCase(addProduct.pending, (state) => {
        state.addLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccessMessage =
          action.payload.message || "تم إضافة المنتج بنجاح";
        state.success = action.payload.message || "تم إضافة المنتج بنجاح";
        // إضافة المنتج الجديد للقائمة
        if (action.payload.data) {
          state.products.unshift(action.payload.data);
        }
        // console.log('Product added successfully:', action.payload);
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.addLoading = false;
        state.addError = action.payload || { message: "حدث خطأ في إضاقة المنتج" };
      })

      // Update product
      .addCase(updateProduct.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.success = action.payload.message || "تم تحديث المنتج بنجاح";
        state.updateSuccessMessage =
          action.payload.message || "تم تحديث المنتج بنجاح";
        // تحديث المنتج في القائمة
        const index = state.products.findIndex(
          (product) => product.id === action.payload.data.id
        );
        if (index !== -1) {
          state.products[index] = action.payload.data;
        }
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload || { message: "حدث خطأ في تحديث المنتج" };
      })

      // Delete product
      .addCase(deleteProduct.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.success =
          action.payload.response.message || "تم حذف المنتج بنجاح";
        // حذف المنتج من القائمة
        state.products = state.products.filter(
          (product) => product.id !== action.payload.id
        );
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload?.message || "حدث خطأ في حذف المنتج";
      })

      // Fetch all categories
      .addCase(fetchAllCategories.pending, (state) => {
        state.categoriesLoading = true;
        state.error = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.categoriesLoading = false;
        // console.log("Categories fulfilled:", action.payload);
        state.categories = action.payload.data || [];
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.categoriesLoading = false;
        state.error = action.payload?.message || "حدث خطأ في تحميل التصنيفات";
      })

      // Fetch all grades
      .addCase(fetchAllGrades.pending, (state) => {
        state.gradesLoading = true;
        state.error = null;
      })
      .addCase(fetchAllGrades.fulfilled, (state, action) => {
        state.gradesLoading = false;
        // console.log("Grades fulfilled:", action.payload);
        state.grades = action.payload.data || [];
      })
      .addCase(fetchAllGrades.rejected, (state, action) => {
        state.gradesLoading = false;
        state.error = action.payload?.message || "حدث خطأ في تحميل الصفوف";
      })
      // Fetch all products
      .addCase(fetchAllProducts.pending, (state) => {
        state.allProductsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action) => {
        state.allProductsLoading = false;
        state.allProducts = action.payload.data || [];
        state.meta = action.payload.meta || {};
      })
      .addCase(fetchAllProducts.rejected, (state, action) => {
        state.allProductsLoading = false;
        state.error = action.payload?.message || "حدث خطأ في تحميل المنتجات";
      })

      // Fetch all subjects
      .addCase(fetchAllSubjects.pending, (state) => {
        state.subjectsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllSubjects.fulfilled, (state, action) => {
        state.subjectsLoading = false;
        // console.log("Subjects fulfilled:", action.payload);
        state.subjects = action.payload.data || [];
      })
      .addCase(fetchAllSubjects.rejected, (state, action) => {
        state.subjectsLoading = false;
        state.error = action.payload?.message || "حدث خطأ في تحميل المواد";
      })

      // Fetch all sections
      .addCase(fetchAllSections.pending, (state) => {
        state.sectionsLoading = true;
        state.error = null;
      })
      .addCase(fetchAllSections.fulfilled, (state, action) => {
        state.sectionsLoading = false;
        // console.log("Sections fulfilled:", action.payload);
        state.sections = action.payload.data || [];
      })
      .addCase(fetchAllSections.rejected, (state, action) => {
        state.sectionsLoading = false;
        state.error = action.payload?.message;
      });
  },
});

export const { clearState } = productSlice.actions;
export default productSlice.reducer;
